import { render, staticRenderFns } from "./buyprice.vue?vue&type=template&id=22c73067&scoped=true"
import script from "./buyprice.vue?vue&type=script&lang=js"
export * from "./buyprice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c73067",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22c73067')) {
      api.createRecord('22c73067', component.options)
    } else {
      api.reload('22c73067', component.options)
    }
    module.hot.accept("./buyprice.vue?vue&type=template&id=22c73067&scoped=true", function () {
      api.rerender('22c73067', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/agent/buyprice.vue"
export default component.exports